import React, { useState } from "react";
import Markdown from "../Markdown/Markdown";
import { Separator } from "@/components/ui/separator";
import {
  AiOutlineRobot,
  AiOutlineLike,
  AiOutlineDislike,
  AiFillLike,
  AiFillDislike,
} from "react-icons/ai";
import { IoIosLink } from "react-icons/io";
import { sendFeedback } from "../../services/api/ManagerService";
import { Button } from "@/components/ui/button";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import toast from "react-hot-toast";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";
import { Textarea } from "../ui/textarea";
import BaseButton from "../Buttons/BaseButton";
import { IoLeafOutline } from "react-icons/io5";
import { storeCache } from "../../services/api/CacheService";
import {
  AiOutlineSafetyCertificate,
  AiFillSafetyCertificate,
} from "react-icons/ai";

function FeedbackDialog({ feedbackTrigger, onSendFeedback }) {
  const [reason, setReason] = useState("");

  return (
    <Dialog>
      <DialogTrigger>
        {feedbackTrigger === "negative" ? (
          <AiOutlineDislike className="h-6 w-6 cursor-pointer" />
        ) : (
          <AiOutlineLike className="h-6 w-6 cursor-pointer" />
        )}
      </DialogTrigger>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Leave a comment</DialogTitle>
          <DialogDescription>
            <div className="mt-4">
              <Textarea
                value={reason}
                onChange={(e) => setReason(e.target.value)}
              />
              <div className="mt-2 flex justify-end">
                <BaseButton
                  value={"Send Feedback"}
                  onClick={() => onSendFeedback(reason)}
                />
              </div>
            </div>
          </DialogDescription>
        </DialogHeader>
      </DialogContent>
    </Dialog>
  );
}

function BotMessageV2({
  query,
  message,
  chatbots,
  documents,
  onSelected,
  cached,
  context,
  otherChatbots,
  agentIsActive,
}) {
  const [liked, setLiked] = useState(false);
  const [disliked, setDisliked] = useState(false);
  const [feedback, setFeedback] = useState(false);
  const [showSources, setShowSources] = useState(false);

  // const handleSendPositiveFeedback = async () => {
  //   setLiked(true);
  //   setDisliked(false);
  //   const payload = {
  //     user_sub: localStorage.getItem("sub"),
  //     query: query,
  //     answer: message,
  //     is_correct: true,
  //     source: "chat",
  //     chatbot: chatbots.join(","), // chatbot is an array
  //   };
  //   if (feedback) return;

  //   const res = await sendFeedback(chatbots[0], payload); // work around because the endpoint need the chatbot name, but we are sending the payload to store multiple chatbots
  //   if (res) {
  //     toast.success(
  //       "We received your feedback! Thanks to help Chatto to perform better. 😀"
  //     );
  //     setFeedback(true);
  //   }
  // };

  const handleSendFeedback = async (is_correct, reason) => {
    if (is_correct) {
      setLiked(true);
      setDisliked(false);
    } else {
      setDisliked(true);
      setLiked(false);
    }
    const payload = {
      user_sub: localStorage.getItem("sub"),
      query: query,
      answer: message,
      expected_answer: reason,
      is_correct: is_correct,
      source: agentIsActive
        ? "agent"
        : chatbots.length === 0
        ? "queryRouter"
        : "chat",
      chatbot: chatbots.join(","), // chatbot is an array
    };
    if (feedback) return;

    let res;
    if (chatbots.length === 0 || agentIsActive === true) {
      res = await sendFeedback("dgs-agent", payload);
    } else {
      res = await sendFeedback(chatbots[0], payload); // work around because the endpoint need the chatbot name, but we are sending the payload to store multiple chatbots
    }
    if (res) {
      toast.success("We received your feedback!");
      setFeedback(true);
    }
  };

  const handleStoreCache = async () => {
    const payload = {
      query: query,
      answer: message,
      sources: documents,
      index_name: chatbots,
    };
    const res = await storeCache(payload);
    if (res) {
      toast.success("We stored your question for future reference.");
    }
  };

  console.log("Message context - Agent is Active?", agentIsActive);

  return (
    <div className="bg-gray-200 p-5 rounded-lg">
      <Markdown text={message} />
      <Separator className="my-4 bg-gray-300" />

      {localStorage.getItem("company_name") === "DGS_GRIDSPERTISE" &&
        chatbots.length > 0 && (
          <div className="text-xs text-gray-500 mb-2">
            Want to discover more about the resolution?
          </div>
        )}
      <div className="flex flex-wrap justify-between items-center gap-2">
        {chatbots.length > 0 ? (
          <div className="flex flex-wrap items-center gap-2">
            {chatbots.map((chatbot) => (
              <Button
                key={chatbot}
                className="bg-transparent border text-gray border-primary flex gap-1 hover:bg-primary hover:text-white"
                onClick={() => onSelected(chatbot)}
              >
                <AiOutlineRobot className="h-4 w-4" />
                <span className="text-xs">Chat with {chatbot}</span>
              </Button>
            ))}
          </div>
        ) : (
          <div className="flex items-center gap-1 text-gray-500"></div>
        )}

        <div className="flex items-center gap-2">
          {cached && (
            <TooltipProvider>
              <Tooltip>
                <TooltipTrigger className="flex items-center text-gray-500 cursor-help">
                  <AiFillSafetyCertificate className="h-6 w-6 text-primary" />
                </TooltipTrigger>
                <TooltipContent>
                  <p>
                    Questa risposta è stata verificata. Riduciamo i costi e
                    miglioriamo l’esperienza.
                  </p>
                </TooltipContent>
              </Tooltip>
            </TooltipProvider>
          )}

          {localStorage.getItem("is_builder") === "true" && !cached && (
            <TooltipProvider>
              <Tooltip>
                <TooltipTrigger className="flex items-center text-gray-500 cursor-help">
                  <AiOutlineSafetyCertificate
                    className="h-6 w-6 cursor-pointer hover:text-primary"
                    onClick={handleStoreCache}
                  />
                </TooltipTrigger>
                <TooltipContent>
                  <p>
                    Clicca per verificare questa risposta se la ritieni
                    corretta.
                  </p>
                </TooltipContent>
              </Tooltip>
            </TooltipProvider>
          )}

          {liked ? (
            <AiFillLike
              className="h-6 w-6 cursor-pointer text-primary"
              onClick={() => setLiked(false)}
            />
          ) : (
            <FeedbackDialog
              feedbackTrigger="positive"
              onSendFeedback={(r) => handleSendFeedback(true, r)}
            />
          )}

          {disliked ? (
            <AiFillDislike
              className="h-6 w-6 cursor-pointer text-red-500"
              onClick={() => setDisliked(false)}
            />
          ) : (
            <FeedbackDialog
              feedbackTrigger="negative"
              onSendFeedback={(r) => handleSendFeedback(false, r)}
            />
          )}
        </div>
      </div>

      <div className="mt-2 flex flex-col justify-start gap-2">
        {localStorage.getItem("company_name") === "DGS_GRIDSPERTISE" &&
          otherChatbots.length > 0 && (
            <>
              <div className="text-xs text-gray-500">
                If you need to explore the associate use case knowledge base:
              </div>
            </>
          )}
        {otherChatbots &&
        otherChatbots[0] !== undefined &&
        otherChatbots.length > 0 ? (
          <div className="flex flex-wrap items-center gap-2">
            {otherChatbots.map((chatbot) => (
              <Button
                key={chatbot}
                className="bg-transparent border text-gray border-primary flex gap-1 hover:bg-primary hover:text-white"
                onClick={() => onSelected(chatbot)}
              >
                <AiOutlineRobot className="h-4 w-4" />
                <span className="text-xs">Chat with {chatbot}</span>
              </Button>
            ))}
          </div>
        ) : (
          <div className="flex items-center gap-1 text-gray-500"></div>
        )}
      </div>

      {documents && documents.length > 0 && (
        <div className="mt-4">
          <button
            onClick={() => setShowSources((prev) => !prev)}
            className="text-xs text-primary underline hover:text-primary/80 transition"
          >
            {showSources ? "Nascondi fonti" : "Mostra fonti"}
          </button>

          {showSources && (
            <div className="mt-1 pl-3 border-l-2 border-primary/40 text-xs text-gray-700 space-y-1">
              {documents.map((doc, i) => {
                const matchingContexts = context.filter((ctx) =>
                  ctx?.metadata?.source?.includes(doc)
                );
                const pagesSet = new Set(
                  matchingContexts
                    .map((ctx) => ctx?.metadata?.page)
                    .filter(Boolean)
                );
                const pages = Array.from(pagesSet).sort((a, b) => a - b);

                return (
                  <div key={i}>
                    {doc.startsWith("http") ? (
                      <a
                        href={doc}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-blue-600 underline break-words"
                      >
                        {doc}
                      </a>
                    ) : (
                      <span className="break-words">{doc}</span>
                    )}
                    {pages.length > 0 && (
                      <span className="text-gray-500">
                        {" "}
                        [page {pages.join(", ")}]
                      </span>
                    )}
                  </div>
                );
              })}
            </div>
          )}
        </div>
      )}
    </div>
  );
}

export default BotMessageV2;
